import { useMutation, useQuery, useQueryClient } from "react-query";

import axiosInstance from "../config/Axios";

import { useCustomToast } from "../pages/Contexts/ToastContext";

export const getUserSubscription = async () => {
  const { data } = await axiosInstance.get(`/company/details`);

  return data?.data;
}

// The resolved support contact (WhatsApp number etc.) for the caller's company. Reachable
// without a subscription (the backend route sits outside the subscription gate).
const getSupportContact = async () => {
  const { data } = await axiosInstance.get(`/support-contact`);

  return data?.data?.support ?? null;
}

export const useSupportContact = (enabled = true) =>
  useQuery('supportContact', getSupportContact, { enabled, staleTime: 1000 * 60 * 30, retry: false });

export const useGetUserSubscription = () => {
  const { showToast } = useCustomToast();

  let { isLoading, data, error, isError } = useQuery('getUserSubscription', getUserSubscription, {
    cacheTime: 1000 * 60 * 30, // Cache data for 30 minutes
    staleTime: 1000 * 60 * 30, // Data is fresh for 30 minutes
    onError: (error) => {
      showToast("error", "Fetching Data", error.response?.data?.message || "An unknown error occurred");

    }
  });

  return { isLoading, data };
}


const updateUserProfile = async (updatedData) => {
  const formData = new FormData();
  formData.append("name", updatedData.name);
  const { data } = await axiosInstance.post(`/users/update`, formData);
  return data;
};

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();
  const { showToast } = useCustomToast();

  const mutation = useMutation(updateUserProfile, {
    onSuccess: async (data) => {
      localStorage.setItem("name", data?.data?.name);
      showToast("success", "Update User Profile", "Profile Updated Successfully!");
      queryClient.invalidateQueries("getUserSubscription");
    },
    onError: (error) => {
      showToast("error", "Update User Profile", error?.response?.data?.message || "An error occurred.");
    },
  });

  return mutation;
};
